import React from 'react';
import {withTranslation} from "react-i18next";
import ToOverviewComponent from "./ToOverviewComponent";

let OrderDetailNotFoundComponent = ({t}) => {
    return <div className="order-not-found">
        {t('reward.claim.notFound')}
        <ToOverviewComponent/>
    </div>
};

export default withTranslation() (OrderDetailNotFoundComponent)